import ExpertShowroomDetail, {
  getStaticProps,
  getStaticPaths,
} from '@public/ExpertDetail/Showroom'

export { getStaticProps, getStaticPaths }

export default ExpertShowroomDetail
